import { string, object } from "yup";
import i18next from "/app/src/locales/config";

export const connectionPathSchema = object().shape({
  value: string().trim().required(i18next.t("translation:required")),
});
